const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSegmentWiseReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 393.89,
    width: 55.13,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.89,
    y: 394.01,
    width: 6.29,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.66,
    y: 389.63,
    width: 11.72,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.14,
    y: 389.63,
    width: 64.46,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.57,
    y: 394.26,
    width: 42,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.67,
    y: 394.26,
    width: 13.35,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.66,
    y: 389.75,
    width: 35.61,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.87,
    y: 73.63,
    width: 245.92,
    height: 158.8,
    transform: "translate(639.66 306.06) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.17,
    y: 73.63,
    width: 247.89,
    height: 158.8,
    transform: "translate(634.23 306.06) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.87,
    y: 232.43,
    width: 245.92,
    height: 3.57,
    transform: "translate(639.66 468.43) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.24,
    y: 232.43,
    width: 239.79,
    height: 3.57,
    transform: "translate(592.26 468.43) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.45,
    y: 34.27,
    width: 145.33,
    height: 237.52,
    transform: "translate(470.14 -164.09) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378 225.69 347.56 80.37 308.73 80.37 339.16 225.69 378 225.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.18 225.69 297.74 80.37 279.72 80.37 310.16 225.69 328.18 225.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.17,
    y: 144.64,
    width: 131.03,
    height: 0.66,
    transform: "translate(343.65 -53.71) rotate(90)",
    style: {
      fill: "#d4e1fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.68,75V131.5h-15s-26.87-17.53-33-53.59a6,6,0,0,1,5.9-7h38A4.07,4.07,0,0,1,446.68,75Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.68,220.57V134.5h-15s-8.6,17.38-17.17,37.36a35,35,0,0,0,32.13,48.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.67,
    y: 129.94,
    width: 16.97,
    height: 4.56,
    rx: 1.5,
    transform: "translate(878.3 264.44) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.93,75V131.5h15s26.88-17.53,33-53.59a6,6,0,0,0-5.9-7H193A4.07,4.07,0,0,0,188.93,75Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.93,220.57V134.5h15s8.6,17.38,17.18,37.36a35,35,0,0,1-32.14,48.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.98,
    y: 129.94,
    width: 16.97,
    height: 4.56,
    rx: 1.5,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.97,
    y: 97.51,
    width: 58.28,
    height: 87.05,
    transform: "translate(212.22 282.07) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.54,
    y: 97.51,
    width: 65.22,
    height: 87.05,
    transform: "translate(202.29 282.07) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.35,
    y: 115.15,
    width: 73.6,
    height: 51.77,
    transform: "translate(242.18 39.89) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.67,156v-8.87a21,21,0,0,0-21-21h0V135a21,21,0,0,0,21,21Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 280.63,
    width: 42.91,
    height: 101.76,
    transform: "translate(423.48 663.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.74 382.4 190.28 382.4 190.28 363.2 213.76 363.2 201.74 382.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.47,
    y: 280.63,
    width: 42.91,
    height: 101.76,
    transform: "translate(855.85 663.03) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.29,
    y: 280.63,
    width: 226.18,
    height: 95.15,
    transform: "translate(606.75 656.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.01 382.4 416.47 382.4 416.47 363.2 393 363.2 405.01 382.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.17,
    y: 290.03,
    width: 208.41,
    height: 33.16,
    transform: "translate(606.75 613.22) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.17,
    y: 332.91,
    width: 208.41,
    height: 33.16,
    transform: "translate(606.75 698.98) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.76,
    y: 290.03,
    width: 171.82,
    height: 33.16,
    transform: "translate(643.33 613.22) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.46,299.11H253.2c-5.76,8.45-8.56,24.08,5.13,24.08S269.23,307.56,263.46,299.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.35,245.77h18.48s-3.21,7.77-3.21,12.35,14.05,22.51-6,22.51-6-17.93-6-22.51S363.35,245.77,363.35,245.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,270.33c0,5.67-9.75,10.3-21.67,10.3H305.69c-11.92,0-21.67-4.63-21.67-10.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.59,312.89c0,5.67-6.57,10.3-14.6,10.3h-7.26c-8,0-14.6-4.63-14.6-10.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.59,306.61c0,5.67-6.57,10.3-14.6,10.3h-7.26c-8,0-14.6-4.63-14.6-10.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.76,
    y: 332.91,
    width: 171.82,
    height: 33.16,
    transform: "translate(643.33 698.98) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.45,355.77c0,5.66-6.57,10.3-14.6,10.3H272.6c-8,0-14.61-4.64-14.61-10.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.45,349.49c0,5.67-6.57,10.3-14.6,10.3H272.6c-8,0-14.61-4.63-14.61-10.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.29,355.77c0,5.66-6.58,10.3-14.61,10.3h-7.25c-8,0-14.61-4.64-14.61-10.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.29,349.49c0,5.67-6.58,10.3-14.61,10.3h-7.25c-8,0-14.61-4.63-14.61-10.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.42,364.45c-2.53-26.16-4.8-99.23-3.32-112.35l3.5-2.56s-1.07,47.72.81,87.79.27,21.16,1.06,27.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.65,312.41c-7.05-5.54-21.47-9.48-36.15-9.46C62.73,303,86,309.4,95.73,316.5c7.53,5.52,16,14.8,18.91,19.95C112.77,325.61,111.71,318,104.65,312.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.64,320.6c5.86-5.77,19.38-10.2,34-10.71,5.74-.19-16.12,7.05-24.27,14.47-6.34,5.77-12.84,15.31-14.63,20.55C113.33,334,112.78,326.37,118.64,320.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.34,273.33c-6-4.69-18.18-8-30.62-8-4.88,0,14.86,5.46,23.06,11.48,6.38,4.67,13.57,12.53,16,16.89C111.21,284.51,110.31,278,104.34,273.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.18,280.27c5-4.89,16.41-8.64,28.81-9.07,4.86-.16-13.65,6-20.56,12.25-5.36,4.88-10.86,13-12.38,17.4C111.69,291.65,111.22,285.16,116.18,280.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.3,244.53c3.53-4,12.08-7.37,21.53-8.24,3.71-.35-10.11,5.18-15.05,10.32-3.84,4-7.61,10.45-8.53,13.93C110.48,253.48,109.77,248.5,113.3,244.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,247.17c-2.55-3.43-8.61-6.41-15.26-7.24-2.61-.33,7.19,4.53,10.75,9a38,38,0,0,1,6.25,12C113.14,254.85,113.54,250.6,111,247.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,382.4h0a14.59,14.59,0,0,1-14.56-13.75L99,356.37h31.7l-1.28,12.28A14.6,14.6,0,0,1,114.88,382.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.79 361.44 96.98 361.44 95.95 352.15 133.81 352.15 132.79 361.44",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,188.17c-.51,1.51-1,2.81-1.54,4.18s-1.1,2.69-1.68,4c-1.17,2.67-2.47,5.28-3.88,7.86a75.09,75.09,0,0,1-4.74,7.58,44.75,44.75,0,0,1-6.2,7.08c-.62.55-1.25,1.1-1.95,1.61-.37.27-.64.5-1.09.79s-.88.55-1.35.8a13,13,0,0,1-6.29,1.51,14.77,14.77,0,0,1-5.81-1.32,21.88,21.88,0,0,1-4.43-2.7,35.58,35.58,0,0,1-6.42-6.72c-.91-1.18-1.72-2.43-2.5-3.68s-1.48-2.49-2.17-3.9l4.65-2.89c.8.93,1.72,2,2.62,2.92s1.85,1.87,2.79,2.76a34.06,34.06,0,0,0,5.87,4.52c2,1.16,4,1.74,5.21,1.54a4,4,0,0,0,1.68-.66l.42-.32c.12-.09.37-.33.56-.48.4-.34.8-.74,1.19-1.14a53.73,53.73,0,0,0,8.26-12.47c1.21-2.33,2.31-4.74,3.39-7.17.53-1.21,1.05-2.44,1.54-3.67s1-2.51,1.42-3.63Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,184.59c1.56,6.79-13.33,24.15-13.33,24.15L304.28,199a88.87,88.87,0,0,1,10.62-15.78C321,176.25,329.28,177.14,331,184.59Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,184.59c1.56,6.79-13.33,24.15-13.33,24.15L304.28,199a88.87,88.87,0,0,1,10.62-15.78C321,176.25,329.28,177.14,331,184.59Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59,183.58a163.76,163.76,0,0,0-6.16,23.62c-1.05,5.59-1.81,10.94-2.38,15.8-1.34,11.39-1.65,20.12-2.18,23.05l-38.62-5.2c-2.62-41.7,8.84-62.36,8.84-62.36a76.1,76.1,0,0,1,9.36-.55c.66,0,1.33,0,2,.05a143.67,143.67,0,0,1,16.42,2.21c1,.19,2.07.41,3.08.64C359.1,182,363.59,183.58,363.59,183.58Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59,183.58a163.76,163.76,0,0,0-6.16,23.62c-1.05,5.59-1.81,10.94-2.38,15.8-1.34,11.39-1.65,20.12-2.18,23.05l-38.62-5.2c-2.62-41.7,8.84-62.36,8.84-62.36a76.1,76.1,0,0,1,9.36-.55c.66,0,1.33,0,2,.05a143.67,143.67,0,0,1,16.42,2.21c1,.19,2.07.41,3.08.64C359.1,182,363.59,183.58,363.59,183.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.43,207.2c-1.05,5.59-1.81,10.94-2.38,15.8l-5.22-12.06Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.43,207.2c-1.05,5.59-1.81,10.94-2.38,15.8l-5.22-12.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295 403.3 288.12 400.91 291.81 384.33 298.69 386.72 295 403.3",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.2 407.21 353.92 407.21 348.24 390.33 355.53 390.33 361.2 407.21",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.81 384.34 289.9 392.88 296.79 395.27 298.69 386.72 291.81 384.34",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.53 390.34 348.24 390.34 351.17 399.04 358.46 399.04 355.53 390.34",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.87,390.4l11.67,4s11.41-45,15-67.43c1.08-6.82,3.52-16.26,6.46-26.34,3.7-12.7,8.21-26.4,11.87-37.12,3.87-11.29,6.77-19.27,6.77-19.27l-25.39-3.42s-19.34,59.3-21.52,81.43C290.45,345.29,287.87,390.4,287.87,390.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.87,390.4l11.67,4s11.41-45,15-67.43c1.08-6.82,3.52-16.26,6.46-26.34,3.7-12.7,8.21-26.4,11.87-37.12,3.87-11.29,6.77-19.27,6.77-19.27l-25.39-3.42s-19.34,59.3-21.52,81.43C290.45,345.29,287.87,390.4,287.87,390.4Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,300.66c3.7-12.7,8.21-26.4,11.87-37.12l-2.27-5.87C323.79,264.78,320.58,287.94,321,300.66Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.94,242.7s-1.25,62.42.46,83.7c1.88,23.3,19.34,71,19.34,71h13.35s-8.91-43.61-11.64-66.24c-3.11-25.78,3.41-85.06,3.41-85.06Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.94,242.7s-1.25,62.42.46,83.7c1.88,23.3,19.34,71,19.34,71h13.35s-8.91-43.61-11.64-66.24c-3.11-25.78,3.41-85.06,3.41-85.06Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.94,406.36h8.89a.64.64,0,0,1,.62.5l1.44,6.48a1.07,1.07,0,0,1-1.07,1.29c-2.86-.05-4.94-.21-8.54-.21-2.22,0-8.9.23-11.95.23s-3.46-3-2.21-3.3c5.61-1.23,9.84-2.92,11.64-4.54A1.79,1.79,0,0,1,352.94,406.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.44,400.13l7.52,2.6a.65.65,0,0,1,.43.68l-.76,6.59a1.06,1.06,0,0,1-1.42.88c-2.69-1-6.56-2.5-10-3.68-4-1.38-7.5-2.35-12.18-4-2.82-1-2.62-4.11-1.34-4,5.79.69,10.23,2.08,15.88.82A3.48,3.48,0,0,1,288.44,400.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.62,205.28l2.94-7.4-9.3-.32a7,7,0,0,0,1.8,8.11Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.57 192.9 279.28 194.31 276.26 197.56 285.56 197.88 286.57 192.9",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.68,208.32a5.84,5.84,0,0,1-4-1.61,8,8,0,0,1-2.29-6.3c.21-4.7,3.65-8.89,7.65-9.33a5.89,5.89,0,0,1,4.74,1.56,8,8,0,0,1,2.29,6.3c-.21,4.71-3.65,8.9-7.65,9.34A5.58,5.58,0,0,1,332.68,208.32Zm2-16.28-.58,0c-3.53.39-6.57,4.16-6.77,8.39a7,7,0,0,0,2,5.52,4.89,4.89,0,0,0,3.95,1.31c3.53-.4,6.57-4.16,6.77-8.39a7.07,7.07,0,0,0-2-5.53A4.88,4.88,0,0,0,334.69,192Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,161.49c-1.74,5.15-4.08,14.69-.86,18.71a16.55,16.55,0,0,1-13.34,3.33c-4.53-.71-4.33-3.92-3.08-5.54,6.08-.61,6.52-5,6-9.25Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.16,164.45l-6.65,4.29a17.59,17.59,0,0,1,.11,3c2.3,0,5.72-2.08,6.28-4.4A7.88,7.88,0,0,0,347.16,164.45Z",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37,140.85c-5.64-.46-7.6,13.13-4.08,15.74S348.94,141.71,338.37,140.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.44,153.63c-1.4,7.09-1.86,11.32-6,14.5-6.18,4.79-14.57.33-15.31-7-.67-6.64,1.74-17.12,9.12-19A9.86,9.86,0,0,1,353.44,153.63Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,160.57c-3.5,2.18-6.86-17.19,2.84-16.74C366.73,144.39,359.43,156,352,160.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.56,147.28c-4.66-2.59-11.62.66-16.39-1.61s-12.95-.28-9.11-7.23c1.16,2,6.14,2.12,8.73-.72s6-3.66,8-.55,7.55-3.11,12.28.89C362.17,141.49,361.59,151.19,354.56,147.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39,145.64s4.22-.14,5-2.33C363.44,145.47,362.39,146.89,358.39,145.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.61,162a6.91,6.91,0,0,1-4.65,2.44c-2.4.19-3.15-2.06-2.1-4.09.94-1.83,3.33-4.13,5.55-3.38A3.08,3.08,0,0,1,355.61,162Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.14 397.64 361.86 397.64 361.86 392.94 344.29 392.64 346.14 397.64",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.32 390.16 300.21 394.97 301.76 390.49 286.31 384.87 286.32 390.16",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 341.63,
    cy: 154.07,
    rx: 1.06,
    ry: 0.7,
    transform: "translate(143.32 472.07) rotate(-82.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.74,153.28c-.08.58-.45,1-.83,1s-.63-.56-.55-1.15.45-1,.83-1S335.82,152.7,335.74,153.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,153.85a21,21,0,0,1-3.45,4.61,3.37,3.37,0,0,0,2.71.89Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.3,161.24a5.14,5.14,0,0,1-.77-.05.18.18,0,0,1-.15-.19.18.18,0,0,1,.2-.15,4.66,4.66,0,0,0,4-1.3.18.18,0,0,1,.25,0,.17.17,0,0,1,0,.24A4.91,4.91,0,0,1,339.3,161.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.64,152.31a.34.34,0,0,1-.3-.17,2.76,2.76,0,0,0-2-1.44.35.35,0,1,1,.05-.69,3.47,3.47,0,0,1,2.59,1.79.34.34,0,0,1-.13.47A.33.33,0,0,1,344.64,152.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.21,150.63a.41.41,0,0,1-.19,0,.35.35,0,0,1-.1-.48,3.45,3.45,0,0,1,2.72-1.6.35.35,0,0,1,.34.35.34.34,0,0,1-.34.34h0a2.73,2.73,0,0,0-2.13,1.29A.35.35,0,0,1,333.21,150.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.54,407.64a2.2,2.2,0,0,1-1.41-.38,1,1,0,0,1-.35-.91.55.55,0,0,1,.29-.49c.81-.4,3.16,1,3.42,1.2a.18.18,0,0,1,.08.17.16.16,0,0,1-.13.14A8,8,0,0,1,350.54,407.64Zm-1.09-1.51a.48.48,0,0,0-.22,0c-.05,0-.1.07-.11.2a.71.71,0,0,0,.23.63,3.55,3.55,0,0,0,2.59.13A7,7,0,0,0,349.45,406.13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.4,407.38l-.08,0c-.75-.41-2.21-2-2.06-2.82a.56.56,0,0,1,.55-.45.92.92,0,0,1,.74.22c.84.69,1,2.79,1,2.88a.16.16,0,0,1-.07.16A.19.19,0,0,1,352.4,407.38Zm-1.47-3h-.08c-.22,0-.24.13-.25.17-.09.48.84,1.69,1.59,2.26a4.2,4.2,0,0,0-.86-2.28A.6.6,0,0,0,350.93,404.42Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.44,400.85h0c-1.18-.17-3.25-.58-3.77-1.51a1,1,0,0,1,0-.9.54.54,0,0,1,.41-.34c1-.19,3.28,2.19,3.54,2.46a.17.17,0,0,1,0,.19A.18.18,0,0,1,287.44,400.85Zm-3.29-2.41h-.07a.24.24,0,0,0-.16.14.62.62,0,0,0,0,.59c.29.53,1.4,1,3,1.26C286,399.53,284.73,398.44,284.15,398.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.44,400.85a.17.17,0,0,1-.12-.05c-.7-.66-1.83-2.72-1.44-3.45.09-.18.3-.36.77-.25a1.25,1.25,0,0,1,.8.59,4.92,4.92,0,0,1,.15,3,.17.17,0,0,1-.11.12Zm-1.05-3.44a.21.21,0,0,0-.21.1c-.23.44.48,2,1.15,2.8a4.06,4.06,0,0,0-.17-2.44.92.92,0,0,0-.59-.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.63,192.06c-.13,1.48-.28,2.79-.48,4.15s-.41,2.7-.64,4c-.48,2.69-1.05,5.36-1.74,8s-1.51,5.3-2.46,7.94l-.74,2-.84,2c-.26.65-.59,1.3-.91,2l-.47,1-.12.25-.21.39a8.89,8.89,0,0,1-.5.82,15,15,0,0,1-4.12,3.9,33.51,33.51,0,0,1-4,2.24,62.56,62.56,0,0,1-7.8,3.06,103.78,103.78,0,0,1-15.75,3.71l-1.38-5.29c4.74-1.9,9.54-3.94,14.08-6.1a70.47,70.47,0,0,0,6.47-3.47,24,24,0,0,0,2.7-1.89,6,6,0,0,0,1.46-1.57s0,0,0,0,0,0,0,0l.08-.21.32-.82c.22-.55.44-1.09.62-1.67l.58-1.7.53-1.74c.67-2.34,1.28-4.73,1.8-7.17s1-4.9,1.4-7.37.78-5,1.09-7.36Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,187.71c4.08,5.65-.63,23.07-.63,23.07l-19.12.61a135,135,0,0,1,4.38-20C356.67,182.05,364,180.86,369,187.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,187.71c4.08,5.65-.63,23.07-.63,23.07l-19.12.61a135,135,0,0,1,4.38-20C356.67,182.05,364,180.86,369,187.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.85,121.45A108.06,108.06,0,0,0,185,112.53c-52,0-93.13,37.82-98.79,87.45l6.45-3.11,98,20.66Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.85,121.45A108.06,108.06,0,0,0,185,112.53c-52,0-93.13,37.82-98.79,87.45l6.45-3.11,98,20.66Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.29,118.34a108,108,0,0,0-42.87-8.92c-52,0-93.13,37.82-98.79,87.45l104.48,17.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.29,118.34a108,108,0,0,0-42.87-8.92c-52,0-93.13,37.82-98.79,87.45l104.48,17.55Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,114.13,210.8,210.21l92.41,55,6.45-3.11s7.14-33.37,6.14-51.93c-2.25-41.4-61.37-99.19-61.37-99.19Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,114.13,210.8,210.21l92.41,55,6.45-3.11s7.14-33.37,6.14-51.93c-2.25-41.4-61.37-99.19-61.37-99.19Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,111,217.24,207.1l92.42,55a100.58,100.58,0,0,0,12.58-55C319.92,164.19,292.18,127.31,254.43,111Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,111,217.24,207.1l92.42,55a100.58,100.58,0,0,0,12.58-55C319.92,164.19,292.18,127.31,254.43,111Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.26,254a.22.22,0,0,1-.13,0l-82.59-49.19a.25.25,0,0,1-.1-.31l33-85.36a.25.25,0,0,1,.35-.14,108,108,0,0,1,41.27,36.61,104,104,0,0,1,17.41,51.86,96,96,0,0,1-9,46.42.25.25,0,0,1-.16.14ZM225,204.43l82.17,48.94A95.46,95.46,0,0,0,316,207.43c-2-37.1-24.29-70.77-58.16-87.92Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4,
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.28,207.94h0L99.35,192.17a.27.27,0,0,1-.16-.1.26.26,0,0,1,0-.19,92.28,92.28,0,0,1,31.59-55.15,94.7,94.7,0,0,1,60.67-21.56,101.66,101.66,0,0,1,35.23,6.3.2.2,0,0,1,.14.13.27.27,0,0,1,0,.2l-33.28,86A.25.25,0,0,1,193.28,207.94ZM99.69,191.72l93.43,15.69,33.11-85.56a101.22,101.22,0,0,0-34.82-6.18C145.26,115.67,107.57,146.93,99.69,191.72Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4,
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,217.53l-98-20.66L86.18,200a104.24,104.24,0,0,0-.51,17.55c3.14,58,52.7,105,110.69,105,37.8,0,69.85-20,86.71-50Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,217.53l-98-20.66L86.18,200a104.24,104.24,0,0,0-.51,17.55c3.14,58,52.7,105,110.69,105,37.8,0,69.85-20,86.71-50Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.11,214.42,92.63,196.87a105.29,105.29,0,0,0-.52,17.55c3.15,58,52.7,105,110.69,105,37.81,0,69.86-20,86.72-50Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.11,214.42,92.63,196.87a105.29,105.29,0,0,0-.52,17.55c3.15,58,52.7,105,110.69,105,37.81,0,69.86-20,86.72-50Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.8,313.67c-54.89,0-102-44.67-105-99.56a100.13,100.13,0,0,1,0-10.25.21.21,0,0,1,.09-.18.23.23,0,0,1,.2-.06l96.93,16.28.08,0,86.26,51.38a.25.25,0,0,1,.12.16.27.27,0,0,1,0,.19,91.5,91.5,0,0,1-33.53,30.91A95.94,95.94,0,0,1,202.8,313.67ZM98.31,204.16c-.15,3.3-.14,6.63,0,9.92,3,54.63,49.82,99.09,104.45,99.09,32.45,0,60.91-15.15,78.11-41.56l-86-51.22Z",
    style: {
      fill: "#fafafa",
      opacity: 0.4,
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.66,230.76a112.16,112.16,0,0,1-1.49-13l1-.06a109.61,109.61,0,0,0,1.47,12.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.66,230.76a112.16,112.16,0,0,1-1.49-13l1-.06a109.61,109.61,0,0,0,1.47,12.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,241c-.56-2-1.07-4.12-1.51-6.17l1-.21c.44,2,.94,4.09,1.49,6.12Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,241c-.56-2-1.07-4.12-1.51-6.17l1-.21c.44,2,.94,4.09,1.49,6.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.42,232.13l-7.14-1.92,1.55,9.17s6.44.29,7-3.11Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.66 232.54 316.3 240.07 321.83 239.38 320.28 230.21 314.66 232.54",
    style: {
      fill: "#e4897b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentWiseReports);
export default __webpack_public_path__ + "static/media/segment-wise-reports.6ea49eb16d66716b645ba97f9f7f7257.svg";
export { ForwardRef as ReactComponent };